export const REDUCER_NAME="walletSlice"

interface iWalletTransactionResponse {
  id: string;
  userId: string;
  walletId: string;
  recipientUserId?: string | null;
  currentBalance: number;
  previousBalance: number;
  transactionType: string;
  paymentStatus: 'PENDING' | 'PROCESSING' | 'APPROVED' | 'REJECTED' | 'SUCCESS' | 'FAILED';
  transactionId?: string | null;
  paymentSessionId?: string | null;
  paymentMode?: string | null;
  paymentMessage?: string | null;
  paymentResponse?: any | null; 
  createdAt: string; 
  updatedAt: string; 
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  orderId:string;
  transactionAmount:string;
  accountholderName:string;
  ifscCode:string;
  bankAccountNumber:string;
  fundAccountId:string;
  contactId:string;
}
interface iWallet {
  userId: string;
  balance: number;
  holdBalance: number;
}
interface iWalletAndHoldTransactionsResponse {
  wallet: iWallet | null;
  holdTransactions: iWalletTransactionResponse[];
}
export interface iminimumWalletAmount{
  minimumWalletAmountForReseller:number;
  minimumWalletAmountForWholesaler:number;
}
  
export interface iWalletState {
      isLoading: boolean;
      walletTransactionList: iWalletTransactionResponse[];
      errorMessage: string | null;
      mimimumWalletAmount:iminimumWalletAmount;
      holdMoneyInfo:iWalletAndHoldTransactionsResponse|null
    }

export interface iWithdrawDTO{
      amount?:number;
      accountHolderName?:string;
      bankAccountNumber?:string;
      ifscCode?:string;
      }

      export interface iApprovedStatus{
        paymentMessage?:string;
        paymentStatus?:string;
      }
